module.exports = __webpack_public_path__ + "img/yongdian.86a060a1.svg";